module.exports = __webpack_public_path__ + "img/ic_more.df730e1c.svg";